import type { EventSourceMessage } from '@microsoft/fetch-event-source';
import type { AppDispatch } from 'src/infra/stores/store';
import { handleNotificationEvent } from './handlers/notificationEventHandler';
import { handleFileStatusUpdateEvent } from './handlers/fileStatusUpdateEventHandler';
import { handleDownloadUrlEvent } from './handlers/downloadUrlEventHandler';
import { handleBackgroundShipmentResultEvent } from './handlers/backgroundShipmentResultEventHandler';

/**
 * SSE Event Router
 * Routes incoming SSE messages to appropriate handlers
 *
 * This keeps the SSEInitializer clean and makes it easy to add new event types
 */
export const routeSSEEvent = (event: EventSourceMessage, dispatch: AppDispatch): void => {
  // Skip connection establishment messages
  if (event.data === 'Stream established') {
    return;
  }

  // Route to appropriate handler based on event type
  switch (event.event) {
    case 'notification':
      handleNotificationEvent(event, dispatch);
      break;

    case 'fileStatusUpdate':
      handleFileStatusUpdateEvent(event, dispatch);
      break;

    case 'downloadUrl':
      handleDownloadUrlEvent(event, dispatch);
      break;

    case 'backgroundShipmentResult':
      handleBackgroundShipmentResultEvent(event, dispatch);
      break;

    default:
      console.warn(`🤷 SSE: Unknown event type: ${event.event}`);
      break;
  }
};
